var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", [_vm._v(_vm._s(_vm.label))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c("color-picker", {
            attrs: {
              color: _vm.value,
              enabled: _vm.enabled,
              lastColor: _vm.lastValue
            },
            on: {
              "change-color": function($event) {
                return _vm.$emit("input", $event)
              },
              "set-last-color": function($event) {
                _vm.lastValue = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c("Checkbox", {
            attrs: { text: "" },
            model: {
              value: _vm.enabled,
              callback: function($$v) {
                _vm.enabled = $$v
              },
              expression: "enabled"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }